import React, { ReactNode, useCallback } from "react";

import { useAttribution } from "../../hooks/useAttribution";
import { Routes } from "../../route/routes";
import { GoogleIcon } from "../login/GoogleLogin";
import { LoginOption } from "../login/LoginOption";

interface GoogleSignupProps {
  authQueryParams: Record<string, string>;
  children?: ReactNode;
  disabled?: boolean;
  onSubmit: () => void;
}

export const GoogleSignup: React.ComponentType<GoogleSignupProps> = React.memo(
  function GoogleSignup({
    authQueryParams,
    children,
    disabled = false,
    onSubmit,
  }) {
    const attribution = useAttribution();
    const googleCallback = useCallback(async () => {
      onSubmit();
      const url = Routes.GOOGLE_SIGNUP.getUrl({
        attribution,
        queryParams: authQueryParams,
      });
      window.location.href = url;
    }, [authQueryParams, onSubmit, attribution]);

    return (
      <LoginOption
        disabled={disabled}
        icon={<GoogleIcon />}
        onClick={googleCallback}
      >
        {children ?? (
          <>
            Sign up with <span>Google</span>
          </>
        )}
      </LoginOption>
    );
  },
);
